import { styled, alpha } from '@mui/material/styles';
import { ListItemText, ListItemButton, ListItemIcon, Stack } from '@mui/material';
// next
import NextLink from 'next/link';
import { useRouter } from 'next/router';
// components
import Avatar from '../../../components/Avatar';
// config
import { NAVBAR } from '../../../config';
import { getActiveCompany } from '..';

export const ListItemStyle = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'activeRoot' && prop !== 'activeSub' && prop !== 'subItem',
})(({ activeRoot, activeSub, subItem, theme }) => ({
  ...theme.typography.subtitle2,
  overflow: 'hidden',
  position: 'relative',
  height: NAVBAR.DASHBOARD_ITEM_COMPANY_HEIGHT,
  padding: theme.spacing(2, 1.5),
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  // activeRoot
  ...(activeRoot && {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[200],
  }),
  // activeSub
  ...(activeSub && {
    color: theme.palette.text.primary,
  }),
  // subItem
  ...(subItem && {
    height: NAVBAR.DASHBOARD_ITEM_SUB_HEIGHT,
  }),
}));

export const ListItemTextStyle = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isCollapse',
})(({ isCollapse, theme }) => ({
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  width: '170px',
  transition: theme.transitions.create(['width', 'opacity'], {
    duration: theme.transitions.duration.shorter,
  }),
  ...(isCollapse && {
    width: 0,
    opacity: 0,
  }),
}));

export const ListItemIconStyle = styled(ListItemIcon)({
  width: 32,
  height: 32,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': { width: '100%', height: '100%' },
});


export function CompanyItem({company}) {
  const { id, name, path, contract_hours } = company;
  
  const { asPath } = useRouter();

  const active = getActiveCompany(id, asPath);

  const renderContent = (
    <>
      <ListItemIconStyle>
        <Avatar
          src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/images/bji_${id%4 + 1}.png`}
          alt={name}
          color={'default'}
          sx={{
            margin: 'auto',
            width: 32,
            height: 32,
          }}
        />
      </ListItemIconStyle>
      <Stack>
      <ListItemTextStyle
        primary={name}
        primaryTypographyProps={{
          noWrap: true,
          variant: 'subtitle2',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          transition: 'width 0.5s',
        }}
        secondary={`주 ${contract_hours}시간 근무 중`}
        secondaryTypographyProps={{
          noWrap: true,
          variant: 'caption',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          color: 'inherit',
        }}
      />
      </Stack>
    </>
  );

  return (
    <NextLink href={path} passHref>
      <ListItemStyle activeRoot={active}>{renderContent}</ListItemStyle>
    </NextLink>
  )
}